import React, { useState } from 'react';
import { achievementDefinitions } from '../data/achievements';
import { PlayerAchievement, AchievementCategory } from '../types/achievements';
import AchievementBadge from './AchievementBadge';
import { useLocalStorage } from '../hooks/useLocalStorage';

const CATEGORIES: { label: string; value: AchievementCategory | 'ALL' }[] = [
  { label: 'All', value: 'ALL' },
  { label: 'Gameplay', value: 'GAMEPLAY' },
  { label: 'Streak', value: 'STREAK' },
  { label: 'Speed', value: 'SPEED' },
  { label: 'Challenge', value: 'CHALLENGE' },
  { label: 'Daily', value: 'DAILY' },
  { label: 'Milestone', value: 'MILESTONE' },
];

const AchievementsPanel: React.FC = () => {
  const [achievements] = useLocalStorage<PlayerAchievement[]>('histocracy_achievements', []);
  const [filter, setFilter] = useState<AchievementCategory | 'ALL'>('ALL');

  const unlockedIds = new Set(achievements.map((a) => a.id));
  const filtered =
    filter === 'ALL'
      ? achievementDefinitions
      : achievementDefinitions.filter((d) => d.category === filter);

  const unlockedCount = achievementDefinitions.filter((d) => unlockedIds.has(d.id)).length;

  return (
    <div className="achievements-panel">
      <h2 className="achievements-title">Achievements</h2>
      <p className="achievements-subtitle">
        {unlockedCount} / {achievementDefinitions.length} unlocked
      </p>

      <div className="achievements-filter-bar">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.value}
            className={`achievements-filter-btn ${filter === cat.value ? 'active' : ''}`}
            onClick={() => setFilter(cat.value)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <div className="achievements-grid">
        {filtered.map((def) => (
          <AchievementBadge
            key={def.id}
            definition={def}
            unlocked={unlockedIds.has(def.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default AchievementsPanel;
